module.exports = __webpack_public_path__ + "media/assets/images/icons/profile-generic/profile-medium-5e20112af033111cdcbab5530fdcc3e3.jpg";